import create from 'zustand';

export const useReportStore = create((set) => ({
  // Report state
  reportState: { 
    isReportOpen: false, 
    contentId: "", 
    contentType: "" 
  },
  
  // Actions
  setReportState: (reportState) => set({ reportState }),
  
  setReportOpen: (isOpen) => set((state) => ({ 
    reportState: { ...state.reportState, isReportOpen: isOpen } 
  })),
  
  setReportContent: (contentId, contentType) => set((state) => ({ 
    reportState: { ...state.reportState, contentId, contentType } 
  })),
  
  openReport: (contentId, contentType) => set({ 
    reportState: { isReportOpen: true, contentId, contentType } 
  }),
  
  closeReport: () => set({ 
    reportState: { isReportOpen: false, contentId: "", contentType: "" } 
  }),
  
  // Reset report state
  resetReportState: () => set({ 
    reportState: { isReportOpen: false, contentId: "", contentType: "" } 
  }),
}));
